import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "footer" };
const _hoisted_2 = { class: "footer__inner" };
const _hoisted_3 = { class: "footer__row" };
const _hoisted_4 = { class: "footer__col" };
const _hoisted_5 = { class: "footer__label" };
const _hoisted_6 = ["href"];
const _hoisted_7 = { class: "footer__sub" };
const _hoisted_8 = { class: "footer__col footer__col--social" };
const _hoisted_9 = { class: "footer__label" };
const _hoisted_10 = { class: "footer__socials" };
const _hoisted_11 = ["href", "aria-label"];
const _hoisted_12 = ["href", "aria-label"];
const _hoisted_13 = { class: "footer__bottom" };
const _hoisted_14 = { class: "footer__copy" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_router_link = _resolveComponent("router-link");
    return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("section", _hoisted_4, [
                    _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t('footer.contactLabel')), 1),
                    _createElementVNode("a", {
                        href: `mailto:${_ctx.$t('footer.email')}`,
                        class: "footer__email"
                    }, _toDisplayString(_ctx.$t('footer.email')), 9, _hoisted_6),
                    _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t('footer.responseTime')), 1)
                ]),
                _createElementVNode("section", _hoisted_8, [
                    _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.$t('footer.socialLabel')), 1),
                    _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("a", {
                            href: _ctx.$t('footer.instagramUrl'),
                            class: "footer__social-link",
                            "aria-label": _ctx.$t('footer.instagramLabel'),
                            target: "_blank",
                            rel: "noopener noreferrer"
                        }, [...(_cache[0] || (_cache[0] = [
                                _createElementVNode("svg", {
                                    viewBox: "0 0 24 24",
                                    fill: "currentColor",
                                    "aria-hidden": "true"
                                }, [
                                    _createElementVNode("path", { d: "M12 2.16c3.2 0 3.58.01 4.85.07 1.17.05 1.8.25 2.23.41.56.22.96.48 1.38.9.42.42.68.82.9 1.38.16.42.36 1.06.41 2.23.06 1.27.07 1.65.07 4.85s-.01 3.58-.07 4.85c-.05 1.17-.25 1.8-.41 2.23-.22.56-.48.96-.9 1.38-.42.42-.82.68-1.38.9-.42.16-1.06.36-2.23.41-1.27.06-1.65.07-4.85.07s-3.58-.01-4.85-.07c-1.17-.05-1.8-.25-2.23-.41-.56-.22-.96-.48-1.38-.9-.42-.42-.68-.82-.9-1.38-.16-.42-.36-1.06-.41-2.23C2.17 15.58 2.16 15.2 2.16 12s.01-3.58.07-4.85c.05-1.17.25-1.8.41-2.23.22-.56.48-.96.9-1.38.42-.42.82-.68 1.38-.9.42-.16 1.06-.36 2.23-.41C8.42 2.17 8.8 2.16 12 2.16zM12 0C8.74 0 8.33.01 7.05.07 5.78.13 4.9.33 4.14.63c-.79.31-1.46.72-2.13 1.39C1.35 2.69.94 3.36.63 4.14.33 4.9.13 5.78.07 7.05.01 8.33 0 8.74 0 12s.01 3.67.07 4.95c.06 1.27.26 2.15.56 2.91.31.79.72 1.46 1.39 2.13.67.67 1.34 1.08 2.13 1.39.76.3 1.64.5 2.91.56C8.33 23.99 8.74 24 12 24s3.67-.01 4.95-.07c1.27-.06 2.15-.26 2.91-.56.79-.31 1.46-.72 2.13-1.39.67-.67 1.08-1.34 1.39-2.13.3-.76.5-1.64.56-2.91.06-1.28.07-1.69.07-4.95s-.01-3.67-.07-4.95c-.06-1.27-.26-2.15-.56-2.91-.31-.79-.72-1.46-1.39-2.13-.67-.67-1.34-1.08-2.13-1.39-.76-.3-1.64-.5-2.91-.56C15.67.01 15.26 0 12 0zm0 5.84c-3.4 0-6.16 2.76-6.16 6.16s2.76 6.16 6.16 6.16 6.16-2.76 6.16-6.16S15.4 5.84 12 5.84zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm6.41-11.85c-.8 0-1.44.65-1.44 1.44 0 .8.65 1.44 1.44 1.44.8 0 1.44-.65 1.44-1.44 0-.8-.65-1.44-1.44-1.44z" })
                                ], -1)
                            ]))], 8, _hoisted_11),
                        _createElementVNode("a", {
                            href: _ctx.$t('footer.linkedinUrl'),
                            class: "footer__social-link",
                            "aria-label": _ctx.$t('footer.linkedinLabel'),
                            target: "_blank",
                            rel: "noopener noreferrer"
                        }, [...(_cache[1] || (_cache[1] = [
                                _createElementVNode("svg", {
                                    viewBox: "0 0 24 24",
                                    fill: "currentColor",
                                    "aria-hidden": "true"
                                }, [
                                    _createElementVNode("path", { d: "M20.45 20.45h-3.55v-5.57c0-1.33-.03-3.04-1.85-3.04-1.85 0-2.13 1.45-2.13 2.94v5.67H9.36V9h3.41v1.56h.05c.48-.9 1.63-1.85 3.36-1.85 3.6 0 4.26 2.37 4.26 5.45v6.29zM5.34 7.43c-1.14 0-2.06-.92-2.06-2.06s.92-2.06 2.06-2.06 2.06.92 2.06 2.06-.92 2.06-2.06 2.06zm1.78 13.02H3.55V9h3.57v11.45zM22.22 0H1.77C.79 0 0 .77 0 1.72v20.55C0 23.23.79 24 1.77 24h20.45C23.2 24 24 23.23 24 22.27V1.72C24 .77 23.2 0 22.22 0z" })
                                ], -1)
                            ]))], 8, _hoisted_12)
                    ])
                ])
            ]),
            _createElementVNode("div", _hoisted_13, [
                _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.$t('footer.copyright')), 1),
                _createVNode(_component_router_link, {
                    to: _ctx.localizedTo('privacy'),
                    class: "footer__privacy"
                }, {
                    default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('footer.privacy')), 1)
                    ]),
                    _: 1
                }, 8, ["to"])
            ])
        ])
    ]));
}
